<ng-template #popTemplate><div [innerHtml]="vehicle.altText"></div></ng-template>
<figure [tooltip]="popTemplate" placement="top">
    <canvas #iconCanvas></canvas>
    <label>{{vehicle.serialNo}}<br /><span class="small">{{vehicle.model}}</span></label>
</figure>
